var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-body" },
    [
      _c("page-banner", _vm._b({}, "page-banner", _vm.content.banner, false)),
      _c(
        "page-limiter",
        [
          _c(
            "div",
            { staticClass: "breadcrumbs-box" },
            [
              _vm.crumbs && _vm.crumbs.length
                ? _c("breadcrumbs", { attrs: { crumbs: _vm.crumbs } })
                : _vm._e(),
              _c("btn-back")
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "recipe-post", attrs: { id: "recipe-box" } },
            [
              _c("h1", { staticClass: "recipe-post__title" }, [
                _vm._v(_vm._s(_vm.content.title))
              ]),
              _vm.content.meta
                ? _c("post-meta", {
                    staticClass: "recipe-post__meta post-meta--lg",
                    attrs: { content: _vm.content.meta }
                  })
                : _vm._e(),
              _c("article", { staticClass: "recipe-post--body" }, [
                _c("div", { staticClass: "recipe-title-bar" }, [
                  _c("h2", { staticClass: "recipe-title-bar__title" }, [
                    _vm._v(_vm._s(_vm.content.ingsListTitle))
                  ]),
                  _c("div", { staticClass: "recipe-title-bar__portion" }, [
                    _vm._v(
                      "\n\t\t\t\t\t\t" +
                        _vm._s(_vm.content.portionNumberTitle) +
                        "\n\n\t\t\t\t\t\t"
                    ),
                    _c(
                      "div",
                      { staticClass: "recipe-counter" },
                      [
                        _c(
                          "btn",
                          {
                            staticClass:
                              "btn--outline recipe-counter__btn recipe-counter__btn--minus",
                            attrs: { tag: "control" },
                            nativeOn: {
                              click: function($event) {
                                return _vm.portionMinus($event)
                              }
                            }
                          },
                          [_vm._v("\n\t\t\t\t\t\t\t\t-\n\t\t\t\t\t\t\t")]
                        ),
                        _c("div", { staticClass: "recipe-counter__value" }, [
                          _vm._v(_vm._s(_vm.portionCount))
                        ]),
                        _c(
                          "btn",
                          {
                            staticClass:
                              "btn--outline recipe-counter__btn recipe-counter__btn--plus",
                            attrs: { tag: "control" },
                            nativeOn: {
                              click: function($event) {
                                return _vm.portionPlus($event)
                              }
                            }
                          },
                          [_vm._v("\n\t\t\t\t\t\t\t\t+\n\t\t\t\t\t\t\t")]
                        )
                      ],
                      1
                    )
                  ])
                ]),
                _vm.ings && _vm.ings.length
                  ? _c(
                      "ul",
                      { staticClass: "recipe-ings" },
                      _vm._l(_vm.ings, function(item) {
                        return _c(
                          "li",
                          { staticClass: "recipe-ings__item" },
                          [
                            item.link
                              ? _c(
                                  "nuxt-link",
                                  {
                                    staticClass:
                                      "recipe-ings__title recipe-ings__title--link",
                                    attrs: { to: "/" + item.link }
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t" +
                                        _vm._s(item.title) +
                                        "\n\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              : _c("span", {
                                  staticClass: "recipe-ings__title",
                                  domProps: { innerHTML: _vm._s(item.title) }
                                }),
                            _c("span", { staticClass: "recipe-ings__value" }, [
                              _vm._v(
                                _vm._s(item.value) + " " + _vm._s(item.unit)
                              )
                            ])
                          ],
                          1
                        )
                      }),
                      0
                    )
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "recipe-title-bar" },
                  [
                    _c("h2", { staticClass: "recipe-title-bar__title" }, [
                      _vm._v(_vm._s(_vm.content.stepsTitle))
                    ]),
                    _c(
                      "btn",
                      {
                        directives: [
                          {
                            name: "print",
                            rawName: "v-print",
                            value: "#recipe-box",
                            expression: "'#recipe-box'"
                          }
                        ],
                        staticClass: "recipe-title-bar__print btn btn--outline",
                        attrs: { tag: "control", link: "#" }
                      },
                      [_vm._v(_vm._s(_vm.content.stepsPrintBtn))]
                    )
                  ],
                  1
                ),
                _vm.content.steps && _vm.content.steps.length
                  ? _c(
                      "ul",
                      { staticClass: "recipe-steps" },
                      _vm._l(_vm.stepshtml, function(item, index) {
                        return _c(
                          "li",
                          {
                            directives: [
                              {
                                name: "scroll-reveal",
                                rawName: "v-scroll-reveal",
                                value: { delay: 220 + index * 100 },
                                expression: "{delay: 220 + index * 100}"
                              }
                            ],
                            staticClass: "recipe-steps__item"
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t" + _vm._s(item) + "\n\t\t\t\t\t"
                            )
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
                _vm.products && _vm.products.length
                  ? _c("div", { staticClass: "recipe-product" }, [
                      _c("div", { staticClass: "recipe-product__title" }, [
                        _vm._v(_vm._s(_vm.productSection.title))
                      ]),
                      _c(
                        "ul",
                        {
                          directives: [
                            {
                              name: "scroll-reveal",
                              rawName: "v-scroll-reveal"
                            }
                          ],
                          staticClass: "recipe-product__list"
                        },
                        _vm._l(_vm.products, function(item) {
                          return _c(
                            "li",
                            {
                              class: [
                                "recipe-product__list-item",
                                { "recipe-product__list-item--wide": item.wide }
                              ]
                            },
                            [_c("product-tile", { attrs: { content: item } })],
                            1
                          )
                        }),
                        0
                      )
                    ])
                  : _vm._e()
              ]),
              _c("h3", { staticClass: "recipe-wish" }, [
                _vm._v(_vm._s(_vm.content.wish))
              ])
            ],
            1
          ),
          _c("post-social", { staticClass: "recipe-social" })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-428b7d66", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-428b7d66","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/pages/PageRecipesInner.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-428b7d66","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/pages/PageRecipesInner.vue
// module chunks = 1 2